// Mock data for IlinkTrading.com

export const services = [
  {
    id: 1,
    title: 'Web Development',
    slug: 'web-development',
    description: 'Build responsive, scalable web applications with modern technologies. From landing pages to complex enterprise solutions.',
    icon: 'Code',
    color: 'mid-blue',
    features: ['React & Next.js', 'Full-Stack Solutions', 'API Integration', 'Performance Optimization'],
    detailedFeatures: [
      'Custom web application development',
      'Responsive design for all devices',
      'Progressive Web Apps (PWA)',
      'E-commerce platforms',
      'Content Management Systems',
      'RESTful API development'
    ],
    process: [
      { step: 'Discovery', description: 'Understanding your requirements and goals' },
      { step: 'Design', description: 'Creating wireframes and visual designs' },
      { step: 'Development', description: 'Building your application with best practices' },
      { step: 'Testing', description: 'Rigorous QA and performance testing' },
      { step: 'Deployment', description: 'Launch and ongoing support' }
    ],
    benefits: [
      'Faster time to market',
      'Scalable architecture',
      'Enhanced user experience',
      'SEO-friendly structure',
      'Cross-browser compatibility',
      'Mobile-first approach'
    ],
    pricing: {
      basic: { price: '$1,499', features: ['5 Pages', 'Responsive Design', 'Basic SEO', '1 Month Support'] },
      standard: { price: '$2,999', features: ['10 Pages', 'Responsive Design', 'Advanced SEO', 'CMS Integration', '3 Months Support'] },
      premium: { price: '$6,499', features: ['Unlimited Pages', 'Custom Features', 'Premium SEO', 'Full CMS', 'API Integration', '6 Months Support'] }
    }
  },
  {
    id: 2,
    title: 'UI/UX Design',
    slug: 'ui-ux-design',
    description: 'Create intuitive, user-centered designs that deliver exceptional experiences and drive engagement.',
    icon: 'Palette',
    color: 'mid-purple',
    features: ['User Research', 'Wireframing & Prototyping', 'Visual Design', 'Usability Testing'],
    detailedFeatures: [
      'User interface design',
      'User experience research',
      'Interactive prototypes',
      'Design systems',
      'Brand identity design',
      'Usability testing'
    ],
    process: [
      { step: 'Research', description: 'Understanding users and market' },
      { step: 'Wireframing', description: 'Creating layout structures' },
      { step: 'Design', description: 'Visual design and branding' },
      { step: 'Prototype', description: 'Interactive prototype development' },
      { step: 'Testing', description: 'User testing and refinement' }
    ],
    benefits: [
      'Improved user satisfaction',
      'Higher conversion rates',
      'Reduced development costs',
      'Better brand perception',
      'Increased engagement',
      'Competitive advantage'
    ],
    pricing: {
      basic: { price: '$999', features: ['3 Screens', 'Basic Wireframes', 'Style Guide', '2 Revisions'] },
      standard: { price: '$2,499', features: ['10 Screens', 'Interactive Prototype', 'Complete Design System', '5 Revisions'] },
      premium: { price: '$4,999', features: ['20+ Screens', 'Advanced Prototypes', 'Full Brand Guidelines', 'Unlimited Revisions', 'User Testing'] }
    }
  },
  {
    id: 3,
    title: 'Blockchain Development',
    slug: 'blockchain-development',
    description: 'Leverage blockchain technology for secure, decentralized applications and smart contract development.',
    icon: 'Link',
    color: 'dark-blue',
    features: ['Smart Contracts', 'DeFi Solutions', 'NFT Platforms', 'Web3 Integration'],
    detailedFeatures: [
      'Smart contract development',
      'DApp development',
      'Cryptocurrency wallets',
      'NFT marketplaces',
      'Blockchain consulting',
      'Token development'
    ],
    process: [
      { step: 'Consultation', description: 'Blockchain strategy planning' },
      { step: 'Architecture', description: 'System design and selection' },
      { step: 'Development', description: 'Smart contract coding' },
      { step: 'Security Audit', description: 'Comprehensive security review' },
      { step: 'Deployment', description: 'Mainnet launch and monitoring' }
    ],
    benefits: [
      'Enhanced security',
      'Transparency and trust',
      'Reduced intermediaries',
      'Lower transaction costs',
      'Immutable records',
      'Global accessibility'
    ],
    pricing: {
      basic: { price: '$4,999', features: ['Basic Smart Contract', 'Testing', 'Documentation', '1 Month Support'] },
      standard: { price: '$9,999', features: ['Complex Smart Contracts', 'DApp Interface', 'Security Audit', '3 Months Support'] },
      premium: { price: '$24,999', features: ['Full DApp Platform', 'Multiple Contracts', 'Token System', 'Complete Audit', '6 Months Support'] }
    }
  },
  {
    id: 4,
    title: 'E-Commerce Development',
    slug: 'ecommerce-development',
    description: 'Launch powerful online stores with seamless payment integration and inventory management.',
    icon: 'ShoppingCart',
    color: 'mid-green',
    features: ['Shopping Cart Systems', 'Payment Gateways', 'Product Management', 'Analytics Dashboard'],
    detailedFeatures: [
      'Custom e-commerce platforms',
      'Multi-vendor marketplaces',
      'Payment gateway integration',
      'Inventory management',
      'Order tracking systems',
      'Customer portal'
    ],
    process: [
      { step: 'Planning', description: 'Business requirements analysis' },
      { step: 'Design', description: 'Store design and UX' },
      { step: 'Development', description: 'Platform development' },
      { step: 'Integration', description: 'Payment and shipping setup' },
      { step: 'Launch', description: 'Go live and optimization' }
    ],
    benefits: [
      'Increased sales revenue',
      '24/7 availability',
      'Global reach',
      'Lower operational costs',
      'Better customer insights',
      'Automated processes'
    ],
    pricing: {
      basic: { price: '$2,499', features: ['50 Products', 'Payment Gateway', 'Basic Admin', 'Mobile Responsive'] },
      standard: { price: '$4,999', features: ['500 Products', 'Multiple Payment Options', 'Advanced Admin', 'SEO Optimization', 'Analytics'] },
      premium: { price: '$12,499', features: ['Unlimited Products', 'Multi-vendor Support', 'Custom Features', 'Advanced Analytics', 'Marketing Tools'] }
    }
  },
  {
    id: 5,
    title: 'Custom Software Development',
    slug: 'custom-software-development',
    description: 'Tailored software solutions designed to solve your unique business challenges and workflows.',
    icon: 'Settings',
    color: 'mid-orange',
    features: ['Business Process Automation', 'CRM Systems', 'ERP Solutions', 'Legacy System Modernization'],
    detailedFeatures: [
      'Custom business applications',
      'Process automation',
      'System integration',
      'Database design',
      'Cloud migration',
      'Legacy modernization'
    ],
    process: [
      { step: 'Analysis', description: 'Business process analysis' },
      { step: 'Design', description: 'System architecture design' },
      { step: 'Development', description: 'Custom development' },
      { step: 'Integration', description: 'System integration' },
      { step: 'Support', description: 'Ongoing maintenance' }
    ],
    benefits: [
      'Improved efficiency',
      'Cost reduction',
      'Better data management',
      'Competitive advantage',
      'Scalable solutions',
      'Custom fit for your needs'
    ],
    pricing: {
      basic: { price: '$7,499', features: ['Basic Automation', 'Simple Database', 'User Management', '3 Months Support'] },
      standard: { price: '$17,499', features: ['Advanced Features', 'Complex Workflows', 'Integrations', 'Reporting', '6 Months Support'] },
      premium: { price: '$37,499', features: ['Enterprise Solution', 'Full Customization', 'Multiple Integrations', 'Advanced Analytics', '12 Months Support'] }
    }
  },
  {
    id: 6,
    title: 'Mobile App Development',
    slug: 'mobile-app-development',
    description: 'Native and cross-platform mobile applications that deliver seamless experiences on iOS and Android.',
    icon: 'Smartphone',
    color: 'light-yellow',
    features: ['iOS & Android', 'React Native', 'Flutter Development', 'App Store Optimization'],
    detailedFeatures: [
      'iOS app development',
      'Android app development',
      'Cross-platform apps',
      'App design',
      'Backend integration',
      'App store submission'
    ],
    process: [
      { step: 'Concept', description: 'App concept and planning' },
      { step: 'Design', description: 'UI/UX design for mobile' },
      { step: 'Development', description: 'Native or cross-platform development' },
      { step: 'Testing', description: 'Device and OS testing' },
      { step: 'Launch', description: 'App store deployment' }
    ],
    benefits: [
      'Direct customer engagement',
      'Better brand loyalty',
      'Push notifications',
      'Offline functionality',
      'Improved accessibility',
      'Competitive edge'
    ],
    pricing: {
      basic: { price: '$3,499', features: ['Single Platform', '5 Screens', 'Basic Features', 'App Store Submission'] },
      standard: { price: '$7,499', features: ['iOS + Android', '15 Screens', 'Advanced Features', 'Backend Integration', 'Analytics'] },
      premium: { price: '$17,499', features: ['Full Featured App', 'Complex Functionality', 'Real-time Features', 'Push Notifications', '6 Months Support'] }
    }
  },
  {
    id: 7,
    title: '3D Animation',
    slug: '3d-animation',
    description: 'Bring your ideas to life with stunning 3D animations, product visualizations, and interactive experiences.',
    icon: 'Box',
    color: 'mid-pink',
    features: ['Product Visualization', 'Character Animation', '3D Modeling', 'Motion Graphics'],
    detailedFeatures: [
      '3D modeling',
      'Product visualization',
      'Character animation',
      'Architectural visualization',
      'Motion graphics',
      'VR/AR experiences'
    ],
    process: [
      { step: 'Concept', description: 'Storyboard and planning' },
      { step: 'Modeling', description: '3D model creation' },
      { step: 'Texturing', description: 'Materials and textures' },
      { step: 'Animation', description: 'Movement and effects' },
      { step: 'Rendering', description: 'Final output delivery' }
    ],
    benefits: [
      'Engaging visual content',
      'Better product presentation',
      'Increased engagement',
      'Cost-effective prototyping',
      'Enhanced marketing',
      'Competitive differentiation'
    ],
    pricing: {
      basic: { price: '$1,249', features: ['Simple 3D Model', 'Basic Animation', '30 Seconds', '2 Revisions'] },
      standard: { price: '$3,499', features: ['Complex Models', 'Advanced Animation', '60 Seconds', 'Product Visualization', '5 Revisions'] },
      premium: { price: '$7,499', features: ['Full Scene Creation', 'Character Animation', '120+ Seconds', 'Interactive Elements', 'Unlimited Revisions'] }
    }
  },
  {
    id: 8,
    title: 'Cloud Solutions',
    slug: 'cloud-solutions',
    description: 'Scalable cloud infrastructure and migration services to power your digital transformation.',
    icon: 'Cloud',
    color: 'light-blue',
    features: ['AWS & Azure', 'Cloud Migration', 'DevOps & CI/CD', 'Infrastructure as Code'],
    detailedFeatures: [
      'Cloud architecture design',
      'Cloud migration',
      'DevOps implementation',
      'CI/CD pipelines',
      'Container orchestration',
      'Cloud security'
    ],
    process: [
      { step: 'Assessment', description: 'Current infrastructure analysis' },
      { step: 'Planning', description: 'Cloud strategy development' },
      { step: 'Migration', description: 'Phased cloud migration' },
      { step: 'Optimization', description: 'Performance tuning' },
      { step: 'Management', description: 'Ongoing cloud management' }
    ],
    benefits: [
      'Cost optimization',
      'Scalability',
      'High availability',
      'Disaster recovery',
      'Global reach',
      'Faster deployment'
    ],
    pricing: {
      basic: { price: '$3,999', features: ['Basic Migration', 'Cloud Setup', 'Documentation', '1 Month Support'] },
      standard: { price: '$8,999', features: ['Complex Migration', 'DevOps Setup', 'CI/CD Pipeline', '3 Months Support'] },
      premium: { price: '$19,999', features: ['Enterprise Migration', 'Multi-cloud Setup', 'Advanced DevOps', 'Security Implementation', '6 Months Support'] }
    }
  },
  {
    id: 9,
    title: 'Digital Marketing',
    slug: 'digital-marketing',
    description: 'Data-driven marketing strategies that boost your online presence and drive measurable results.',
    icon: 'TrendingUp',
    color: 'dark-green',
    features: ['SEO & SEM', 'Social Media Marketing', 'Content Strategy', 'Analytics & Reporting'],
    detailedFeatures: [
      'SEO optimization',
      'PPC campaigns',
      'Social media management',
      'Content marketing',
      'Email marketing',
      'Analytics and reporting'
    ],
    process: [
      { step: 'Audit', description: 'Current marketing analysis' },
      { step: 'Strategy', description: 'Marketing plan development' },
      { step: 'Implementation', description: 'Campaign execution' },
      { step: 'Optimization', description: 'Continuous improvement' },
      { step: 'Reporting', description: 'Performance tracking' }
    ],
    benefits: [
      'Increased visibility',
      'Higher ROI',
      'Better targeting',
      'Brand awareness',
      'Lead generation',
      'Measurable results'
    ],
    pricing: {
      basic: { price: '$749/mo', features: ['SEO Basics', 'Social Media (2 Platforms)', 'Monthly Reports', '3 Month Minimum'] },
      standard: { price: '$1,999/mo', features: ['Advanced SEO', 'Social Media (4 Platforms)', 'Content Creation', 'PPC Management', 'Weekly Reports'] },
      premium: { price: '$4,999/mo', features: ['Comprehensive SEO', 'All Platforms', 'Full Content Suite', 'Advanced PPC', 'Email Marketing', 'Daily Reports'] }
    }
  },
  {
    id: 10,
    title: 'Creative Copywriting',
    slug: 'creative-copywriting',
    description: 'Compelling content that tells your brand story and converts readers into customers.',
    icon: 'PenTool',
    color: 'mid-purple',
    features: ['Brand Storytelling', 'Website Copy', 'Marketing Content', 'SEO Copywriting'],
    detailedFeatures: [
      'Website copywriting',
      'Blog content',
      'Marketing materials',
      'Email campaigns',
      'Social media content',
      'Brand messaging'
    ],
    process: [
      { step: 'Research', description: 'Brand and audience research' },
      { step: 'Strategy', description: 'Content strategy development' },
      { step: 'Writing', description: 'Content creation' },
      { step: 'Review', description: 'Editing and refinement' },
      { step: 'Delivery', description: 'Final content delivery' }
    ],
    benefits: [
      'Clear messaging',
      'Better engagement',
      'Higher conversions',
      'Brand consistency',
      'SEO benefits',
      'Professional image'
    ],
    pricing: {
      basic: { price: '$499', features: ['5 Pages', 'Basic SEO', '2 Revisions', '1 Week Delivery'] },
      standard: { price: '$1,499', features: ['15 Pages', 'Advanced SEO', '5 Revisions', 'Blog Posts', '2 Week Delivery'] },
      premium: { price: '$3,499', features: ['30+ Pages', 'Premium SEO', 'Unlimited Revisions', 'Full Content Suite', 'Marketing Copy', '3 Week Delivery'] }
    }
  }
];

export const comboPackages = [
  {
    id: 1,
    name: 'Startup Package',
    price: '$4,999',
    description: 'Perfect for new businesses looking to establish their digital presence',
    services: ['Web Development (Basic)', 'UI/UX Design (Basic)', 'Digital Marketing (3 months)'],
    features: [
      'Professional Website (5 pages)',
      'Responsive Design',
      'Basic SEO Setup',
      'Brand Identity Design',
      '3 Months Digital Marketing',
      'Social Media Setup',
      'Analytics Integration',
      '3 Months Support'
    ],
    savings: 'Save $1,497',
    popular: false
  },
  {
    id: 2,
    name: 'Business Growth Package',
    price: '$12,999',
    description: 'Comprehensive solution for growing businesses',
    services: ['Web Development (Standard)', 'E-Commerce (Basic)', 'Mobile App (Basic)', 'Digital Marketing (6 months)'],
    features: [
      'Advanced Website (10 pages)',
      'E-Commerce Store (50 products)',
      'Mobile App (Single Platform)',
      '6 Months Digital Marketing',
      'SEO & Content Strategy',
      'Payment Gateway Integration',
      'Analytics Dashboard',
      '6 Months Support'
    ],
    savings: 'Save $4,996',
    popular: true
  },
  {
    id: 3,
    name: 'Enterprise Package',
    price: '$24,999',
    description: 'Complete digital transformation for established enterprises',
    services: ['Custom Software', 'Web Development (Premium)', 'Mobile App (Premium)', 'Cloud Solutions', 'Digital Marketing (12 months)'],
    features: [
      'Custom Software Solution',
      'Enterprise Website',
      'Full-Featured Mobile App (iOS + Android)',
      'Cloud Infrastructure Setup',
      '12 Months Digital Marketing',
      'Advanced Analytics',
      'API Integrations',
      'Dedicated Support Team',
      '12 Months Premium Support'
    ],
    savings: 'Save $17,995',
    popular: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    role: 'CEO, TechStart Inc.',
    content: 'IlinkTrading transformed our digital presence with a stunning website and mobile app. Their team delivered beyond our expectations, on time and within budget.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400'
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Founder, BlockChain Ventures',
    content: 'The blockchain solution they developed revolutionized our business model. Professional, knowledgeable, and incredibly responsive team.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400'
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    role: 'Marketing Director, GrowthHub',
    content: 'Their digital marketing strategy increased our online visibility by 300%. The ROI has been exceptional. Highly recommend!',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400'
  },
  {
    id: 4,
    name: 'David Kim',
    role: 'CTO, InnovateCo',
    content: 'Outstanding custom software development. They understood our complex requirements and delivered a solution that streamlined our entire operation.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400'
  }
];

export const blogPosts = [
  {
    id: 1,
    slug: 'future-of-web-development-2025',
    title: 'The Future of Web Development in 2025',
    excerpt: 'Explore the latest trends shaping web development, from AI integration to progressive web apps.',
    author: 'John Smith',
    date: '2025-01-15',
    category: 'Web Development',
    image: 'https://images.unsplash.com/photo-1644088379091-d574269d422f?w=800',
    readTime: '5 min read',
    content: `
      <p>The landscape of web development is evolving at an unprecedented pace. As we navigate through 2025, several key trends are reshaping how we build and experience the web.</p>
      
      <h2>AI-Powered Development Tools</h2>
      <p>Artificial intelligence is no longer just a buzzword—it's becoming an integral part of the development workflow. From code completion to automated testing, AI tools are helping developers work faster and more efficiently.</p>
      
      <h2>Progressive Web Apps (PWAs)</h2>
      <p>PWAs continue to bridge the gap between web and native applications. With improved performance, offline capabilities, and app-like experiences, PWAs are becoming the go-to solution for businesses looking to reach users across all platforms.</p>
      
      <h2>WebAssembly and Performance</h2>
      <p>WebAssembly is enabling near-native performance in web applications. This technology is opening doors for complex applications like video editing, gaming, and 3D modeling to run smoothly in the browser.</p>
      
      <h2>Serverless Architecture</h2>
      <p>The serverless revolution continues to gain momentum. Developers are embracing serverless functions to build scalable applications without managing infrastructure, reducing costs and complexity.</p>
      
      <h2>Conclusion</h2>
      <p>The future of web development is exciting and full of possibilities. By staying current with these trends, developers and businesses can create powerful, efficient, and user-friendly web experiences.</p>
    `
  },
  {
    id: 2,
    slug: 'why-business-needs-mobile-app',
    title: 'Why Your Business Needs a Mobile App',
    excerpt: 'Discover how mobile applications can transform customer engagement and drive business growth.',
    author: 'Emma Wilson',
    date: '2025-01-10',
    category: 'Mobile Development',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800',
    readTime: '4 min read',
    content: `
      <p>In today's digital-first world, having a mobile app is no longer a luxury—it's a necessity. Here's why your business should invest in mobile app development.</p>
      
      <h2>Enhanced Customer Engagement</h2>
      <p>Mobile apps provide a direct channel to your customers. With push notifications, in-app messaging, and personalized content, you can engage users more effectively than ever before.</p>
      
      <h2>Improved Brand Recognition</h2>
      <p>A well-designed mobile app keeps your brand at the forefront of customers' minds. Every time users scroll through their phones, they see your app icon—a constant reminder of your brand.</p>
      
      <h2>Better Customer Service</h2>
      <p>Mobile apps enable you to provide instant support through chatbots, help centers, and direct messaging. This immediacy improves customer satisfaction and loyalty.</p>
      
      <h2>Valuable User Data</h2>
      <p>Apps provide valuable insights into user behavior, preferences, and patterns. This data helps you make informed business decisions and tailor your offerings.</p>
      
      <h2>Competitive Advantage</h2>
      <p>While many businesses still rely solely on websites, having a mobile app sets you apart from competitors and positions your business as innovative and customer-centric.</p>
      
      <h2>Conclusion</h2>
      <p>A mobile app is an investment in your business's future. It strengthens customer relationships, increases revenue opportunities, and provides a competitive edge in the digital marketplace.</p>
    `
  },
  {
    id: 3,
    slug: 'blockchain-beyond-cryptocurrency',
    title: 'Blockchain Beyond Cryptocurrency',
    excerpt: 'Understanding the diverse applications of blockchain technology in modern business.',
    author: 'Alex Turner',
    date: '2025-01-05',
    category: 'Blockchain',
    image: 'https://images.pexels.com/photos/1089438/pexels-photo-1089438.jpeg?w=800',
    readTime: '6 min read',
    content: `
      <p>While blockchain technology is often associated with cryptocurrencies, its potential extends far beyond digital currencies. Let's explore how blockchain is transforming various industries.</p>
      
      <h2>Supply Chain Management</h2>
      <p>Blockchain provides unprecedented transparency in supply chains. From tracking food products from farm to table to verifying the authenticity of luxury goods, blockchain ensures accountability at every step.</p>
      
      <h2>Healthcare Records</h2>
      <p>Medical records stored on blockchain are secure, immutable, and easily accessible to authorized healthcare providers. This improves patient care coordination and reduces medical errors.</p>
      
      <h2>Smart Contracts</h2>
      <p>Self-executing contracts with terms written directly into code are revolutionizing industries like real estate, insurance, and legal services. Smart contracts automate processes, reduce costs, and eliminate intermediaries.</p>
      
      <h2>Digital Identity Verification</h2>
      <p>Blockchain-based identity systems give individuals control over their personal data while providing secure verification methods. This is particularly valuable in banking, voting, and government services.</p>
      
      <h2>Intellectual Property Protection</h2>
      <p>Artists, musicians, and creators can use blockchain to prove ownership and track the usage of their work. This technology ensures fair compensation and protects against piracy.</p>
      
      <h2>Future Outlook</h2>
      <p>As blockchain technology matures, we'll see even more innovative applications emerge. The key is understanding how blockchain's core features—transparency, security, and decentralization—can solve real-world problems.</p>
      
      <h2>Conclusion</h2>
      <p>Blockchain is more than just the technology behind Bitcoin. It's a fundamental shift in how we store, verify, and transfer information. Businesses that embrace blockchain early will have a significant advantage in the digital economy.</p>
    `
  }
];

export const companyInfo = {
  name: 'IlinkTrading',
  tagline: 'Transforming Ideas Into Digital Excellence',
  description: 'We are a full-service digital agency specializing in cutting-edge web development, blockchain solutions, and innovative digital marketing strategies. Our mission is to empower businesses with technology that drives growth and creates exceptional user experiences.',
  email: 'hello@ilinktrading.com',
  address: '115 S Church St, Grass Valley, CA 95945, United States',
  founded: '2020',
  projects: '150+',
  clients: '80+',
  teamSize: '25+'
};

export const heroSlides = [
  {
    id: 1,
    title: 'Transforming Ideas',
    subtitle: 'Into Digital Excellence',
    description: 'Full-service digital agency delivering innovative solutions that drive growth',
    bgColor: '#1f47e6',
    textColor: '#ffffff',
    image: 'https://images.unsplash.com/photo-1644088379091-d574269d422f?w=1920&q=85'
  },
  {
    id: 2,
    title: 'Build The Future',
    subtitle: 'With Blockchain',
    description: 'Secure, decentralized solutions powered by cutting-edge technology',
    bgColor: '#d987ff',
    textColor: '#000000',
    image: 'https://images.pexels.com/photos/1089438/pexels-photo-1089438.jpeg?w=1920'
  },
  {
    id: 3,
    title: 'Scale Your Business',
    subtitle: 'In The Cloud',
    description: 'Enterprise-grade cloud solutions for modern businesses',
    bgColor: '#88a2ff',
    textColor: '#000000',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=1920&q=85'
  }
];
